import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { CreateEditHandoverSettingsCommand } from '../model/command/create-edit-handover-settings-command';
import { CreateScaffoldingSystemCommand } from '../model/command/create-scaffolding-system-command';
import { CreateContractTypeCommand } from '../model/command/create-contract-type-command';
import { CreateDiaryCategoryCommand } from '../model/command/create-diary-category-command';
import { DeleteScaffoldingSystemsCommand } from '../model/command/delete-scaffolding-systems-command';
import { DeleteContractTypesCommand } from '../model/command/delete-contract-types-command';
import { EditReportSectionCommand } from '../model/command/edit-report-section-command';
import { EditScaffoldingSystemsCommand } from '../model/command/edit-scaffolding-systems-command';
import { EditContractTypesCommand } from '../model/command/edit-contract-types-command';
import { CreateScaffoldTypeCommand } from '../model/command/create-scaffold-type-command';
import { CreateMethodOfTyingCommand } from '../model/command/create-method-of-tying-command';
import { CreateMethodOfCladdingCommand } from '../model/command/create-method-of-cladding-command';
import { CreateLoadingLimitCommand } from '../model/command/create-loading-limit-command';
import { CreateDesignTypeCommand } from '../model/command/create-design-type-command';
import { CreateDefectTypeCommand } from '../model/command/create-defect-type-command';
import { CreateHandoverRiskReasonCommand } from '../model/command/create-handover-risk-reason-command';
import { CreateHandoverRiskTypeCommand } from '../model/command/create-handover-risk-type-command';
import { CreateTaskTypeCommand } from '../model/command/create-task-type-command';
import { DeleteDiaryCategoryCommand } from '../model/command/delete-diary-category-command';
import { DeleteScaffoldTypesCommand } from '../model/command/delete-scaffold-types-command';
import { DeleteMethodOfTyingsCommand } from '../model/command/delete-method-of-tyings-command';
import { DeleteMethodOfCladdingsCommand } from '../model/command/delete-method-of-claddings-command';
import { DeleteLoadingLimitsCommand } from '../model/command/delete-loading-limits-command';
import { DeleteDesignTypesCommand } from '../model/command/delete-design-types-command';
import { DeleteHandoverRiskReasonsCommand } from '../model/command/delete-handover-risk-reasons-command';
import { DeleteDefectTypesCommand } from '../model/command/delete-defect-types-command';
import { DeleteHandoverRiskTypesCommand } from '../model/command/delete-handover-risk-types-command';
import { DeleteTaskTypesCommand } from '../model/command/delete-task-types-command';
import { EditDiaryCategoryCommand } from '../model/command/edit-diary-category-command';
import { EditCompanyDetailsCommand } from '../model/command/edit-company-details-command';
import { EditScaffoldTypesCommand } from '../model/command/edit-scaffold-types-command';
import { EditMethodOfTyingsCommand } from '../model/command/edit-method-of-tyings-command';
import { EditMethodOfCladdingsCommand } from '../model/command/edit-method-of-claddings-command';
import { EditLoadingLimitsCommand } from '../model/command/edit-loading-limits-command';
import { EditDesignTypesCommand } from '../model/command/edit-design-types-command';
import { EditDefectTypesCommand } from '../model/command/edit-defect-types-command';
import { EditHandoverRiskReasonsCommand } from '../model/command/edit-handover-risk-reasons-command';
import { EditHandoverRiskTypesCommand } from '../model/command/edit-handover-risk-types-command';
import { EditTaskTypeCommand } from '../model/command/edit-task-type-command';
import { DeleteCustomerStatusCommand } from '../model/command/delete-customer-status-command';
import { CreateEditInspectionSettingsCommand } from '../model/command/create-edit-inspection-settings-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Configuration commands to the API.
@Injectable()
export class ConfigurationCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  CreateEditHandoverSettingsCommand(commandData: CreateEditHandoverSettingsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateEditHandoverSettingsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateScaffoldingSystemCommand(commandData: CreateScaffoldingSystemCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateScaffoldingSystemCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateContractTypeCommand(commandData: CreateContractTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateContractTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateDiaryCategoryCommand(commandData: CreateDiaryCategoryCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateDiaryCategoryCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteScaffoldingSystemsCommand(commandData: DeleteScaffoldingSystemsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteScaffoldingSystemsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteContractTypesCommand(commandData: DeleteContractTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteContractTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditReportSectionCommand(commandData: EditReportSectionCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditReportSectionCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditScaffoldingSystemsCommand(commandData: EditScaffoldingSystemsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditScaffoldingSystemsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditContractTypesCommand(commandData: EditContractTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditContractTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateScaffoldTypeCommand(commandData: CreateScaffoldTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateScaffoldTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateMethodOfTyingCommand(commandData: CreateMethodOfTyingCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateMethodOfTyingCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateMethodOfCladdingCommand(commandData: CreateMethodOfCladdingCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateMethodOfCladdingCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateLoadingLimitCommand(commandData: CreateLoadingLimitCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateLoadingLimitCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateDesignTypeCommand(commandData: CreateDesignTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateDesignTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateDefectTypeCommand(commandData: CreateDefectTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateDefectTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateHandoverRiskReasonCommand(commandData: CreateHandoverRiskReasonCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateHandoverRiskReasonCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateHandoverRiskTypeCommand(commandData: CreateHandoverRiskTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateHandoverRiskTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateTaskTypeCommand(commandData: CreateTaskTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateTaskTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteDiaryCategoryCommand(commandData: DeleteDiaryCategoryCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteDiaryCategoryCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteScaffoldTypesCommand(commandData: DeleteScaffoldTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteScaffoldTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteMethodOfTyingsCommand(commandData: DeleteMethodOfTyingsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteMethodOfTyingsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteMethodOfCladdingsCommand(commandData: DeleteMethodOfCladdingsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteMethodOfCladdingsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteLoadingLimitsCommand(commandData: DeleteLoadingLimitsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteLoadingLimitsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteDesignTypesCommand(commandData: DeleteDesignTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteDesignTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteHandoverRiskReasonsCommand(commandData: DeleteHandoverRiskReasonsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteHandoverRiskReasonsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteDefectTypesCommand(commandData: DeleteDefectTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteDefectTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteHandoverRiskTypesCommand(commandData: DeleteHandoverRiskTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteHandoverRiskTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteTaskTypesCommand(commandData: DeleteTaskTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteTaskTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditDiaryCategoryCommand(commandData: EditDiaryCategoryCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditDiaryCategoryCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditCompanyDetailsCommand(commandData: EditCompanyDetailsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditCompanyDetailsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditScaffoldTypesCommand(commandData: EditScaffoldTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditScaffoldTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditMethodOfTyingsCommand(commandData: EditMethodOfTyingsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditMethodOfTyingsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditMethodOfCladdingsCommand(commandData: EditMethodOfCladdingsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditMethodOfCladdingsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditLoadingLimitsCommand(commandData: EditLoadingLimitsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditLoadingLimitsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditDesignTypesCommand(commandData: EditDesignTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditDesignTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditDefectTypesCommand(commandData: EditDefectTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditDefectTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditHandoverRiskReasonsCommand(commandData: EditHandoverRiskReasonsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditHandoverRiskReasonsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditHandoverRiskTypesCommand(commandData: EditHandoverRiskTypesCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditHandoverRiskTypesCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditTaskTypeCommand(commandData: EditTaskTypeCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.EditTaskTypeCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteCustomerStatusCommand(commandData: DeleteCustomerStatusCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.DeleteCustomerStatusCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateEditInspectionSettingsCommand(commandData: CreateEditInspectionSettingsCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Configuration.CreateEditInspectionSettingsCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
